"use client";

// Imagen de producto con respaldo: si el admin todavía no subió foto, se muestra
// un icono acorde al tipo de repuesto en vez de un cuadro vacío.
import { useState } from "react";
import Icon, { IconName } from "./Icon";
import { API_BASE } from "../lib/api";

function iconoPara(nombre: string): IconName {
  const n = nombre.toLowerCase();
  if (n.includes("batería") || n.includes("bateria")) return "battery";
  if (n.includes("módulo") || n.includes("modulo") || n.includes("pantalla") || n.includes("display")) return "smartphone";
  if (n.includes("flex") || n.includes("placa") || n.includes("ic ")) return "cpu";
  if (n.includes("estación") || n.includes("estacion") || n.includes("pinza") || n.includes("herramienta")) return "settings";
  if (n.includes("vidrio") || n.includes("templado") || n.includes("mica")) return "shield";
  return "package";
}

export default function ProductImage({
  productId,
  name,
  hasImage,
  version,
  className = "",
  iconSize = 40,
}: {
  productId: string;
  name: string;
  hasImage: boolean;
  /** imageKey del producto: la URL es fija, así que sin esto una foto nueva
   *  no se veía hasta que venciera el caché de 24 h del navegador. */
  version?: string | null;
  className?: string;
  iconSize?: number;
}) {
  const [fallo, setFallo] = useState(false);

  if (!hasImage || fallo) {
    return (
      <div className={`grid place-items-center bg-[#202829] ${className}`}>
        <Icon name={iconoPara(name)} size={iconSize} className="text-white/15" strokeWidth={1.25} />
      </div>
    );
  }
  const src = `${API_BASE}/store/products/${productId}/image${version ? `?v=${encodeURIComponent(version)}` : ""}`;
  return (
    /* eslint-disable-next-line @next/next/no-img-element */
    <img
      src={src}
      alt={name}
      onError={() => setFallo(true)}
      // En la grilla de la tienda hay decenas de fotos: en 3G bajarlas todas de
      // entrada tapa la conexión y quema el paquete de datos del celular.
      loading="lazy"
      decoding="async"
      className={`object-cover bg-[#202829] ${className}`}
    />
  );
}
